<template>
  <div>
  
  
 <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
	<h4 slot="header" class="title">
     Controller's Current Details
    </h4>
 <card v-if="model.is_company==1" class="form-horizontal">

	   <div style="padding:10px 0px 20px 30px;">
		  <h5  slot="header" class="title">
			 Shareholder/Member Is A Company
		  </h5>
  
		  <br/><strong>Company Name:</strong> {{shareholder_company.company_name}}
		  <br/><strong>Company Registration Number:</strong> {{shareholder_company.company_reg_num}}
		  <br/><strong>Company Address:</strong> {{shareholder_company.address}}
	 	</div>
  </card>
 <card class="form-horizontal">
   <div style="padding:10px 0px 20px 30px;">
   
     <h5 v-if="model.is_company==1" slot="header" class="title">
     Company Representative
    </h5>
  <br/><strong>First Name:</strong> {{person.first_name}}
  <br/><strong>Last Name:</strong> {{person.last_name}}
   <br/><br/> 
    
  <br/><strong>ID No:</strong> {{person.gov_id}}
  <br/><strong>Citizenship:</strong> {{getCitizenship(person.citizenship)}}
  <br/><strong>Nationality:</strong> {{getCountry(person.nationality)}}
  
  <br/><br/> 
   <br/><strong>Address:</strong> {{person.address_1}}
   <br/><strong>Email:</strong> {{person.email}}
   <br/><strong>Contact No:</strong> {{person.contact_num}}
   </div>
   
   
  </card>
       
  <div style="margin-top:100px;">     
    <h4  slot="header" class="title">
     Compliance Update Details
    </h4>
   </div>       
   <card>
   		  <div  class="col-sm-3">
      		 <fg-input label="This Update Is By" >
                  <el-select class="select-primary"
                             size="large" disabled 
                             placeholder="Select Where This Update Is From"
                             v-model="compliance_update.update_by">
                    <el-option v-for="option in selects.compliance_update_by"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
          </div>
          
          
          
   		  <div  class="col-sm-3">
      		 <fg-input label="Update Type" >
                  <el-select class="select-primary"
                             size="large" disabled 
                             placeholder="Select The Type Of Update"
                             v-model="compliance_update.update_type">
                    <el-option v-for="option in selects.compliance_update_type"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
          </div>
          
           <div  class="col-sm-3">
      		 <fg-input label="New Compliance Status" >
                  <el-select class="select-primary"
                             size="large" disabled 
                             placeholder="Select Status"
                             v-model="compliance_update.update_compliance_status">
                    <el-option v-for="option in selects.update_compliance_status"
                               class="select-danger"
                               :value="option.value"
                               :label="option.label"
                               :key="option.label">
                    </el-option>
                  </el-select>
                </fg-input>
          </div>
                
        
        
         <div class="col-sm-3">
       	 <fg-input label="Date Of Update" >
              <el-date-picker 
                format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              	v-model="compliance_update.date_of_update" type="date" placeholder="Select Date"
              	name ="deadline" disabled 
              	:error="getError('date_of_update')"
                v-validate="modelValidations.date_of_update" 
              >
              </el-date-picker>
            </fg-input>
      	</div>
            

        	
        	<div class="col-sm-7">    
                 <fg-input type="text"
                  name="remarks"
				  label="Remarks"     disabled               
                  v-model="compliance_update.remarks">
       			 </fg-input>
            </div>
    
		<!--<p-button  type="info" @click.prevent="submitAddNewComplianceUpdateForm">Add New Update</p-button>-->
   </card>
   
   
   
   <!-- start share certs -->


<card>
  <h4 >Upload Document</h4>
         
       <!-- start upload file-->
          <div class="upload_dropbox">
          <input type="file" multiple :name="uploadFieldName" :disabled="isSaving" 
          @change="upload_filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
            accept="image/*, application/pdf" class="input-file-dropbox">
            <p v-if="isInitial">
              Drag a PDF or JPEG/PNG file here to upload<br> or click to browse
            </p>
            <p v-if="isSaving">
              Uploading {{ fileCount }} files...
            </p>
        </div>
        
        <!-- end upload file-->
   </card>     
        

<div style="margin-top:100px"></div>


        <div class="card" style="margin-bottom:50px">
          <div class="card-header">
              <h5 class="title">Documents</h5>
          </div>
          <div class="card-body table-responsive table-full-width">
            <el-table :data="documents" :row-class-name="scRowClassName">
      
                 <el-table-column label="Document Name" property="document_name"></el-table-column>
                  <el-table-column label="Date Uploaded" property="uploaded_at"></el-table-column>
                 
                 
                 <el-table-column label="Action" property="mode" >
						<template slot-scope="scope">
	
							 <p-button  type="danger"  @click="viewCommonDocument(scope.row.id)" >									
									View
							</p-button>
							
	
							
						</template>
					</el-table-column>
					
					
                 
            </el-table>

          </div>
        </div>


<!-- end certs -->


  </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  import {CommonService} from 'src/services/common.service'
  
   const UPLOAD_STATUS_INITIAL = 0, UPLOAD_STATUS_SAVING = 1, UPLOAD_STATUS_SUCCESS = 2, UPLOAD_STATUS_FAILED = 3;
   
   
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {
        this.initPage();

          
    },
    
     
    data () {
      return {
        coy:[],
    	eid: this.$route.params.eid,
    	shid: this.$route.params.shid,
    	complianceUpdatesTable: [],
    	person:[],
    	documents:[],
    	shareholder_company:[],
        model: {
          first_name: '',
          last_name: '',
          address_1: '',
          status: 1,
          is_contact_person: 2,
          date_appt: '',
          position:'Director',
          nationality:'',
          gov_id:'',
          email:'',
          contact_num:'',
          eid: this.$route.params.eid

        },
        compliance_update:{
        	remarks:'',
        	update_by:1,
        	update_type:3,
        	update_compliance_status: 1,
        	date_of_update:'',
        
        },
        modelValidations: {
          date_of_update: {
            required: true
          },
         
          
        },
         uploadedFiles: [],
         uploadError: null,
         currentStatus: null,
         uploadFieldName: 'uploaded_documents',
        
        selects: {
          officer_status: [
            {value: 1, label: 'Active'},
            {value: 2, label: 'Resigned'},
		   ],
		  is_contact:[
            {value: 1, label: 'Yes'},
            {value: 2, label: 'No'},
		   ],
		   compliance_update_by:[
		   	 {value: 1, label: 'Corp Sec'},
             {value: 2, label: 'Client'},
		   
		   ],
		   compliance_update_type:[
		   	 {value: 1, label: 'Send Compliance Email'},
             {value: 2, label: 'Update From Client'},
             {value: 3, label: 'Corp Sec Updated ACRA'},
		   
		   ],
		    update_compliance_status:[
		   	 {value: 1, label: 'Complete'},
             {value: 2, label: 'Incomplete'},
		   
		   ]    
        },
      }
    },
    computed: {
  
      isInitial() {
        return this.currentStatus === UPLOAD_STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === UPLOAD_STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === UPLOAD_STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === UPLOAD_STATUS_FAILED;
      }
    },
    methods:{
     initPage(){
     	this.upload_reset();
     	let uri = this.$base_url+'/api/v1/entities/get/compliance_update/'+ this.$route.params.cuid;
			 ApiService.get(uri).then(response => {
				
				this.model = response.data.shareholder;
				if(response.data.shareholder.is_company == 1){
					this.shareholder_company = response.data.shareholder.shareholder_company;
					this.person = response.data.shareholder.shareholder_company.person;
				}
				else{
					this.person = response.data.shareholder.person;
				}
				this.coy = response.data.entity_info;
				this.compliance_update = response.data.compliance_update;
				this.documents = response.data.documents;
			    			
			})
     
     },
     scRowClassName({ row }){
    		if(row.status == 4){
    			return "table-success";
    		}
    		else if(row.status == 5){
    			return "cs-strikethrough";
    		}
    	
      },
      getCitizenship(code){
      		if(code){
      			return CommonService.getCitizen(code);
      		}
      },
      getCountry(code){
      		if(code){
      			return CommonService.getCountry(code);
      		}
      },
      goToCertTask(row){
      	this.$router.push( '/edit-task/'+row.task_id+'/entity/'+this.$route.params.eid)
      },
      goToCert(row){
      	this.$router.push( '/view-share-cert/'+row.id+'/entity/'+this.$route.params.eid)
      },
      goToCreateTaskDetails(){
       		this.$router.push( '/create-task-details/'+ this.$route.params.eid+"/sc/"+this.$route.params.shid +"/0" + "/"+this.$route.params.type)
       },
      viewCommonDocument(cdid){
       		this.$router.push( '/view-common-document/' + cdid)  
       },
     goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      deleteComplianceUpdate(cuid){
      		const vm = this;
       	
       	swal({
            title: 'Are you sure?',
            text: 'This compliance update will be deleted.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Yes, delete it!',
            buttonsStyling: false
          }).then(function () {
             const vm_ = vm;
          	 let uri = vm.$base_url+'/api/v1/entities/post/delete_compliance_update/'+cuid+"/"+vm.shid+'/'+vm.eid;
     	 	 ApiService.post(uri).then(response => {
				swal({
				  title: 'Deleted!',
				  text: 'The update has been deleted.',
				  type: 'success',
				  confirmButtonClass: 'btn btn-success btn-fill',
				  buttonsStyling: false
				}).then(function(){
			
					vm.initPage();
				
				})
				//end swal
            })
         
            
          })
      
      
      
      },
      submitAddNewComplianceUpdateForm() {
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
    		 swal({
						  title: 'Oops',
						  text: 'Please enter the date of this update',
						  type: 'error',
						  confirmButtonClass: 'btn btn-success btn-fill',
						  buttonsStyling: false
			 		})
  		  } else {
    		let uri = this.$base_url+'/api/v1/entities/post/add_compliance_update/'+this.shid+'/'+this.eid;
      		ApiService.post(uri, this.compliance_update).then(response => {
      	
         			 this.initPage();
     		 })
  		  }
        
         
        })
      },///end validate+edit
       upload_reset() {
        // reset form to initial state
        this.currentStatus = UPLOAD_STATUS_INITIAL;
        this.uploadedFiles = [];
        this.uploadError = null;
      },
      upload_save(formData) {
        // upload data to the server
        this.currentStatus = UPLOAD_STATUS_SAVING;
		
		/*
        upload(formData)
          .then(x => {
            this.uploadedFiles = [].concat(x);
            this.currentStatus = UPLOAD_STATUS_SUCCESS;
          })
          .catch(err => {
            this.uploadError = err.response;
            this.currentStatus = UPLOAD_STATUS_FAILED;
          });
          */
          
          
         let uri = this.$base_url+'/api/v1/file_upload_common/compliance/'+ this.$route.params.cuid;
         ApiService.post(uri,formData).then(response => {
            	this.currentStatus = UPLOAD_STATUS_SUCCESS;
				this.initPage();
			
		  })
          
      },
      upload_filesChange(fieldName, fileList) {
        // handle file changes
        const formData = new FormData();

        if (!fileList.length) return;

        // append the files to FormData
        Array
          .from(Array(fileList.length).keys())
          .map(x => {
            formData.append(fieldName, fileList[x], fileList[x].name);
          });

        // save it
        this.upload_save(formData);
      },
      
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
</style>


